import axios from 'axios';
import { base_url } from '../utils/APIUrls';
// import { toast } from 'react-toastify';

const token = localStorage.getItem('api_token');

const axiosConnectorInstance = axios.create({
  baseURL: base_url,
  timeout: 60000,
  headers: {
    // 'Content-Type': 'application/json',
    // 'Accept': 'application/json',
    "Authorization": `Bearer ${token}`
  },
});

axiosConnectorInstance.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem("api_token");
    config.headers.Authorization = token ? `Bearer ${token}` : "";
    return config;
  },
);

// axiosConnectorInstance.interceptors.request.use((config) {
//   return config;
// })
// function (error) {
//   console.log("api error: ", error);
//   if (error !== null && error?.response?.status === 401) {
//     window.localStorage.clear();
//     window.location.reload();
//   }

//   return Promise.reject((error) || 'Something went wrong!');
// });

axiosConnectorInstance.interceptors.response.use(function (response: any) {
  console.log("response: ", response);
  return response;
}, function (error: any) {
  console.log("api error: ", error);
  if (error !== null && error?.response?.status === 401) {
    window.localStorage.clear();

    // window.location.reload();
    return Promise.reject((error))
  }

  // toast.error(message);
  return Promise.reject((error) || 'Something went wrong!');
})

export default axiosConnectorInstance;